import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './assets/translations/translationEN.json';
import translationES from './assets/translations/translationES.json';
import translationPT from './assets/translations/translationPT.json';

const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  pt: {
    translation: translationPT,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;